export const dropHighlightSx = (isOver: boolean, color: string) => ({
  boxShadow: isOver
    ? `inset 0 0 0 2px ${color}`
    : 'inset 0 0 0 2px transparent',
  borderRadius: '4px',
  transition: 'box-shadow 0.15s ease',
});
